// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { toast } from 'react-toastify';
// import { Url } from '../url/url'; // 👈 apne project ke hisab se path adjust kar lena
// import { ADD_TYPES, CHILD_ADD_TYPES, TYPE_LABELS, defaultBlock, genId, BlockContent } from './PageBuilderShared';

// // ---- small helpers -------------------------------------------------------

// const AddChildPicker = ({ label, onPick }) => {
//   const [open, setOpen] = useState(false);
//   return (
//     <div style={{ position: 'relative' }} onClick={(e) => e.stopPropagation()}>
//       <button type="button" className="btn btn-sm btn-outline-primary w-100 my-1" onClick={() => setOpen((o) => !o)}>
//         {label}
//       </button>
//       {open && (
//         <div className="border rounded bg-white shadow-sm p-1" style={{ position: 'absolute', zIndex: 20, width: '100%' }}>
//           {CHILD_ADD_TYPES.map((t) => (
//             <button
//               key={t}
//               type="button"
//               className="btn btn-sm btn-light w-100 text-start"
//               onClick={() => {
//                 onPick(t);
//                 setOpen(false);
//               }}
//             >
//               {TYPE_LABELS[t]}
//             </button>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };

// const AlignPicker = ({ value, onChange }) => (
//   <>
//     <label className="small d-block mt-2">Align</label>
//     <select className="form-select form-select-sm mb-2" value={value} onChange={(e) => onChange(e.target.value)}>
//       <option value="left">Left</option>
//       <option value="center">Center</option>
//       <option value="right">Right</option>
//     </select>
//   </>
// );

// const samePath = (a, b) =>
//   a && b && a.id === b.id && !!a.top === !!b.top && a.parentId === b.parentId && a.colId === b.colId;

// // ---- one block in the canvas (editable) ----------------------------------

// const BlockNode = ({ block, path, selected, canMoveUp, canMoveDown, onSelect, onMove, onDuplicate, onDelete, onAddChild }) => {
//   const [hover, setHover] = useState(false);
//   const isSelected = samePath(selected, path);

//   return (
//     <div
//       onMouseEnter={() => setHover(true)}
//       onMouseLeave={() => setHover(false)}
//       onClick={(e) => {
//         e.stopPropagation();
//         onSelect(path);
//       }}
//       style={{
//         position: 'relative',
//         outline: isSelected ? '2px solid #3b82f6' : hover ? '2px dashed #93c5fd' : '1px solid transparent',
//         cursor: 'pointer',
//         marginBottom: 2,
//       }}
//     >
//       {(hover || isSelected) && (
//         <div className="d-flex gap-1" style={{ position: 'absolute', top: 2, right: 2, zIndex: 6 }} onClick={(e) => e.stopPropagation()}>
//           <button type="button" className="btn btn-dark py-0 px-1" style={{ fontSize: 11 }} disabled={!canMoveUp} onClick={() => onMove(path, -1)}>
//             ↑
//           </button>
//           <button type="button" className="btn btn-dark py-0 px-1" style={{ fontSize: 11 }} disabled={!canMoveDown} onClick={() => onMove(path, 1)}>
//             ↓
//           </button>
//           <button type="button" className="btn btn-success py-0 px-1" style={{ fontSize: 11 }} onClick={() => onDuplicate(path)}>
//             ⧉
//           </button>
//           <button type="button" className="btn btn-danger py-0 px-1" style={{ fontSize: 11 }} onClick={() => onDelete(path)}>
//             ✕
//           </button>
//         </div>
//       )}

//       {block.type === 'columns' ? (
//         <div style={{ display: 'flex', gap: block.gap, background: block.rowBackground, padding: 8 }}>
//           {block.columns.map((col, ci) => (
//             <div key={col.id} style={{ width: `${col.width}%`, background: col.background, minHeight: 60, border: '1px dashed #d1d5db', padding: 4 }}>
//               {col.blocks.map((child, idx) => (
//                 <BlockNode
//                   key={child.id}
//                   block={child}
//                   path={{ top: false, parentId: block.id, colId: col.id, id: child.id }}
//                   selected={selected}
//                   canMoveUp={idx > 0}
//                   canMoveDown={idx < col.blocks.length - 1}
//                   onSelect={onSelect}
//                   onMove={onMove}
//                   onDuplicate={onDuplicate}
//                   onDelete={onDelete}
//                   onAddChild={onAddChild}
//                 />
//               ))}
//               <AddChildPicker
//                 label={col.blocks.length === 0 ? `+ Add to Col ${ci + 1}` : '+ Add block'}
//                 onPick={(type) => onAddChild({ parentId: block.id, colId: col.id }, type)}
//               />
//             </div>
//           ))}
//         </div>
//       ) : (
//         <BlockContent block={block} />
//       )}
//     </div>
//   );
// };

// // ---- right-side settings panel -------------------------------------------

// const SettingsPanel = ({ block, onUpdate, onAddColumn, onRemoveColumn, onUpdateColumn, onImageUpload, uploading }) => {
//   if (!block) return <p className="text-muted small">Kisi block pe click karo settings dekhne ke liye</p>;

//   switch (block.type) {
//     case 'banner':
//       return (
//         <>
//           <h6 className="fw-bold">BANNER SETTINGS</h6>
//           <label className="small">Text</label>
//           <textarea className="form-control form-control-sm mb-2" value={block.text} onChange={(e) => onUpdate({ text: e.target.value })} />
//           <label className="small">Background</label>
//           <input type="color" className="form-control form-control-color mb-2" value={block.bgColor} onChange={(e) => onUpdate({ bgColor: e.target.value })} />
//           <label className="small">Text Color</label>
//           <input type="color" className="form-control form-control-color mb-2" value={block.textColor} onChange={(e) => onUpdate({ textColor: e.target.value })} />
//           <label className="small">Height (px)</label>
//           <input type="number" className="form-control form-control-sm mb-2" value={block.height} onChange={(e) => onUpdate({ height: Number(e.target.value) })} />
//           <AlignPicker value={block.align} onChange={(v) => onUpdate({ align: v })} />
//         </>
//       );

//     case 'heading':
//       return (
//         <>
//           <h6 className="fw-bold">HEADING SETTINGS</h6>
//           <label className="small">Text</label>
//           <input className="form-control form-control-sm mb-2" value={block.text} onChange={(e) => onUpdate({ text: e.target.value })} />
//           <label className="small">Font size</label>
//           <input type="number" className="form-control form-control-sm mb-2" value={block.fontSize} onChange={(e) => onUpdate({ fontSize: Number(e.target.value) })} />
//           <label className="small">Color</label>
//           <input type="color" className="form-control form-control-color mb-2" value={block.color} onChange={(e) => onUpdate({ color: e.target.value })} />
//           <AlignPicker value={block.align} onChange={(v) => onUpdate({ align: v })} />
//         </>
//       );

//     case 'text':
//       return (
//         <>
//           <h6 className="fw-bold">TEXT SETTINGS</h6>
//           <label className="small">Content</label>
//           <textarea rows={5} className="form-control form-control-sm mb-2" value={block.content} onChange={(e) => onUpdate({ content: e.target.value })} />
//           <label className="small">Font size</label>
//           <input type="number" className="form-control form-control-sm mb-2" value={block.fontSize} onChange={(e) => onUpdate({ fontSize: Number(e.target.value) })} />
//           <label className="small">Color</label>
//           <input type="color" className="form-control form-control-color mb-2" value={block.color} onChange={(e) => onUpdate({ color: e.target.value })} />
//           <AlignPicker value={block.align} onChange={(v) => onUpdate({ align: v })} />
//         </>
//       );

//     case 'image':
//       return (
//         <>
//           <h6 className="fw-bold">IMAGE SETTINGS</h6>
//           <label className="small">Upload</label>
//           <input type="file" accept="image/*" className="form-control form-control-sm mb-2" disabled={uploading} onChange={onImageUpload} />
//           {uploading && <p className="small text-muted">Uploading...</p>}
//           <label className="small">Alt text</label>
//           <input className="form-control form-control-sm mb-2" value={block.alt} onChange={(e) => onUpdate({ alt: e.target.value })} />
//           <label className="small">Width (%)</label>
//           <input type="range" min={20} max={100} className="form-range mb-2" value={block.width} onChange={(e) => onUpdate({ width: Number(e.target.value) })} />
//           <AlignPicker value={block.align} onChange={(v) => onUpdate({ align: v })} />
//         </>
//       );

//     case 'button':
//       return (
//         <>
//           <h6 className="fw-bold">BUTTON SETTINGS</h6>
//           <label className="small">Label</label>
//           <input className="form-control form-control-sm mb-2" value={block.label} onChange={(e) => onUpdate({ label: e.target.value })} />
//           <label className="small">Link URL</label>
//           <input className="form-control form-control-sm mb-2" value={block.url} onChange={(e) => onUpdate({ url: e.target.value })} />
//           <label className="small">Background</label>
//           <input type="color" className="form-control form-control-color mb-2" value={block.bgColor} onChange={(e) => onUpdate({ bgColor: e.target.value })} />
//           <label className="small">Text Color</label>
//           <input type="color" className="form-control form-control-color mb-2" value={block.textColor} onChange={(e) => onUpdate({ textColor: e.target.value })} />
//           <AlignPicker value={block.align} onChange={(v) => onUpdate({ align: v })} />
//         </>
//       );

//     case 'divider':
//       return (
//         <>
//           <h6 className="fw-bold">DIVIDER SETTINGS</h6>
//           <label className="small">Color</label>
//           <input type="color" className="form-control form-control-color mb-2" value={block.color} onChange={(e) => onUpdate({ color: e.target.value })} />
//           <label className="small">Thickness (px)</label>
//           <input type="number" className="form-control form-control-sm mb-2" value={block.thickness} onChange={(e) => onUpdate({ thickness: Number(e.target.value) })} />
//         </>
//       );

//     case 'spacer':
//       return (
//         <>
//           <h6 className="fw-bold">SPACER SETTINGS</h6>
//           <label className="small">Height (px)</label>
//           <input type="number" className="form-control form-control-sm mb-2" value={block.height} onChange={(e) => onUpdate({ height: Number(e.target.value) })} />
//         </>
//       );

//     case 'social':
//       return (
//         <>
//           <h6 className="fw-bold">SOCIAL SETTINGS</h6>
//           {block.links.map((l, i) => (
//             <div key={i} className="d-flex gap-1 mb-1">
//               <input
//                 className="form-control form-control-sm"
//                 value={l.platform}
//                 onChange={(e) => {
//                   const links = [...block.links];
//                   links[i] = { ...links[i], platform: e.target.value };
//                   onUpdate({ links });
//                 }}
//               />
//               <input
//                 className="form-control form-control-sm"
//                 value={l.url}
//                 onChange={(e) => {
//                   const links = [...block.links];
//                   links[i] = { ...links[i], url: e.target.value };
//                   onUpdate({ links });
//                 }}
//               />
//             </div>
//           ))}
//           <button
//             type="button"
//             className="btn btn-sm btn-outline-primary mb-2"
//             onClick={() => onUpdate({ links: [...block.links, { platform: 'New', url: '#' }] })}
//           >
//             + Add link
//           </button>
//           <AlignPicker value={block.align} onChange={(v) => onUpdate({ align: v })} />
//         </>
//       );

//     case 'footer':
//       return (
//         <>
//           <h6 className="fw-bold">FOOTER SETTINGS</h6>
//           <label className="small">Text</label>
//           <input className="form-control form-control-sm mb-2" value={block.text} onChange={(e) => onUpdate({ text: e.target.value })} />
//           <label className="small">Background</label>
//           <input type="color" className="form-control form-control-color mb-2" value={block.bgColor} onChange={(e) => onUpdate({ bgColor: e.target.value })} />
//           <label className="small">Text Color</label>
//           <input type="color" className="form-control form-control-color mb-2" value={block.textColor} onChange={(e) => onUpdate({ textColor: e.target.value })} />
//         </>
//       );

//     case 'columns':
//       return (
//         <>
//           <h6 className="fw-bold">COLUMNS SETTINGS</h6>
//           <label className="small">Row Background</label>
//           <input
//             type="color"
//             className="form-control form-control-color mb-2"
//             value={block.rowBackground === 'transparent' ? '#ffffff' : block.rowBackground}
//             onChange={(e) => onUpdate({ rowBackground: e.target.value })}
//           />
//           <label className="small">Gap (px)</label>
//           <input type="number" className="form-control form-control-sm mb-3" value={block.gap} onChange={(e) => onUpdate({ gap: Number(e.target.value) })} />

//           <div className="d-flex justify-content-between align-items-center mb-2">
//             <span className="small fw-semibold text-muted">COLUMNS ({block.columns.length})</span>
//             <button type="button" className="btn btn-sm btn-primary" onClick={onAddColumn}>
//               + Add
//             </button>
//           </div>

//           {block.columns.map((col, i) => (
//             <div key={col.id} className="border rounded p-2 mb-2">
//               <div className="d-flex justify-content-between align-items-center mb-1">
//                 <span className="small fw-semibold">Column {i + 1}</span>
//                 {block.columns.length > 1 && (
//                   <button type="button" className="btn btn-sm btn-outline-danger py-0 px-1" onClick={() => onRemoveColumn(col.id)}>
//                     ✕
//                   </button>
//                 )}
//               </div>
//               <label className="small">Width (%)</label>
//               <input
//                 type="number"
//                 className="form-control form-control-sm mb-1"
//                 value={col.width}
//                 onChange={(e) => onUpdateColumn(col.id, { width: Number(e.target.value) })}
//               />
//               <label className="small">Background</label>
//               <input type="color" className="form-control form-control-color" value={col.background} onChange={(e) => onUpdateColumn(col.id, { background: e.target.value })} />
//             </div>
//           ))}
//         </>
//       );

//     default:
//       return null;
//   }
// };

// // ---- presets for the "Templates" dropdown --------------------------------

// const PRESETS = {
//   blank: () => [],
//   textImage: () => [defaultBlock('heading'), defaultBlock('text'), defaultBlock('image')],
//   bannerText: () => [defaultBlock('banner'), defaultBlock('text'), defaultBlock('button')],
// };

// // ---- main component --------------------------------------------------------

// /**
//  * Block-based page builder (email-builder style) for the blog description page.
//  *
//  * Props:
//  *  - initialData: saved JSON string (optional, edit-blog case)
//  *  - onChange(jsonString): parent stores this in formData.builderData
//  */
// const PageBuilder = ({ initialData, onChange }) => {
//   const [blocks, setBlocks] = useState([]);
//   const [canvasWidth, setCanvasWidth] = useState(600);
//   const [canvasBg, setCanvasBg] = useState('#f1f5f9');
//   const [selected, setSelected] = useState(null);
//   const [previewMode, setPreviewMode] = useState(false);
//   const [showTemplates, setShowTemplates] = useState(false);
//   const [uploading, setUploading] = useState(false);

//   useEffect(() => {
//     if (initialData) {
//       try {
//         const parsed = JSON.parse(initialData);
//         setBlocks(parsed.blocks || []);
//         setCanvasWidth(parsed.width || 600);
//         setCanvasBg(parsed.background || '#f1f5f9');
//       } catch (e) {
//         // purana plain description hoga, ignore karo
//       }
//     }
//   }, [initialData]);

//   // ---- tree helpers ----
//   const getBlockAt = (path) => {
//     if (!path) return null;
//     if (path.top) return blocks.find((b) => b.id === path.id);
//     const parent = blocks.find((b) => b.id === path.parentId);
//     const col = parent?.columns.find((c) => c.id === path.colId);
//     return col?.blocks.find((b) => b.id === path.id);
//   };

//   const updateAt = (path, patch) => {
//     setBlocks((prev) => {
//       if (path.top) return prev.map((b) => (b.id === path.id ? { ...b, ...patch } : b));
//       return prev.map((b) => {
//         if (b.id !== path.parentId) return b;
//         return {
//           ...b,
//           columns: b.columns.map((c) => (c.id !== path.colId ? c : { ...c, blocks: c.blocks.map((ch) => (ch.id === path.id ? { ...ch, ...patch } : ch)) })),
//         };
//       });
//     });
//   };

//   const removeAt = (path) => {
//     setBlocks((prev) => {
//       if (path.top) return prev.filter((b) => b.id !== path.id);
//       return prev.map((b) => {
//         if (b.id !== path.parentId) return b;
//         return { ...b, columns: b.columns.map((c) => (c.id !== path.colId ? c : { ...c, blocks: c.blocks.filter((ch) => ch.id !== path.id) })) };
//       });
//     });
//     setSelected(null);
//   };

//   const moveAt = (path, dir) => {
//     setBlocks((prev) => {
//       if (path.top) {
//         const idx = prev.findIndex((b) => b.id === path.id);
//         const newIdx = idx + dir;
//         if (newIdx < 0 || newIdx >= prev.length) return prev;
//         const arr = [...prev];
//         [arr[idx], arr[newIdx]] = [arr[newIdx], arr[idx]];
//         return arr;
//       }
//       return prev.map((b) => {
//         if (b.id !== path.parentId) return b;
//         return {
//           ...b,
//           columns: b.columns.map((c) => {
//             if (c.id !== path.colId) return c;
//             const idx = c.blocks.findIndex((ch) => ch.id === path.id);
//             const newIdx = idx + dir;
//             if (newIdx < 0 || newIdx >= c.blocks.length) return c;
//             const arr = [...c.blocks];
//             [arr[idx], arr[newIdx]] = [arr[newIdx], arr[idx]];
//             return { ...c, blocks: arr };
//           }),
//         };
//       });
//     });
//   };

//   const duplicateAt = (path) => {
//     const block = getBlockAt(path);
//     if (!block) return;
//     const clone = { ...block, id: genId() };
//     if (path.top) {
//       setBlocks((prev) => {
//         const idx = prev.findIndex((b) => b.id === path.id);
//         const arr = [...prev];
//         arr.splice(idx + 1, 0, clone);
//         return arr;
//       });
//     } else {
//       setBlocks((prev) =>
//         prev.map((b) => {
//           if (b.id !== path.parentId) return b;
//           return {
//             ...b,
//             columns: b.columns.map((c) => {
//               if (c.id !== path.colId) return c;
//               const idx = c.blocks.findIndex((ch) => ch.id === path.id);
//               const arr = [...c.blocks];
//               arr.splice(idx + 1, 0, clone);
//               return { ...c, blocks: arr };
//             }),
//           };
//         })
//       );
//     }
//   };

//   const addBlock = (type, colPath = null) => {
//     const block = defaultBlock(type);
//     if (!colPath) {
//       setBlocks((prev) => [...prev, block]);
//       setSelected({ top: true, id: block.id });
//     } else {
//       setBlocks((prev) =>
//         prev.map((b) => {
//           if (b.id !== colPath.parentId) return b;
//           return { ...b, columns: b.columns.map((c) => (c.id === colPath.colId ? { ...c, blocks: [...c.blocks, block] } : c)) };
//         })
//       );
//       setSelected({ top: false, parentId: colPath.parentId, colId: colPath.colId, id: block.id });
//     }
//   };

//   // ---- columns-specific ----
//   const addColumn = () => {
//     if (!selected) return;
//     const block = getBlockAt(selected);
//     if (!block || block.type !== 'columns') return;
//     const newCol = { id: genId(), width: 30, background: '#ffffff', blocks: [] };
//     const cols = [...block.columns, newCol];
//     const evenWidth = Math.floor(100 / cols.length);
//     updateAt(selected, { columns: cols.map((c) => ({ ...c, width: evenWidth })) });
//   };

//   const removeColumn = (colId) => {
//     if (!selected) return;
//     const block = getBlockAt(selected);
//     if (!block || block.type !== 'columns') return;
//     const cols = block.columns.filter((c) => c.id !== colId);
//     const evenWidth = Math.floor(100 / Math.max(cols.length, 1));
//     updateAt(selected, { columns: cols.map((c) => ({ ...c, width: evenWidth })) });
//   };

//   const updateColumnProp = (colId, patch) => {
//     if (!selected) return;
//     const block = getBlockAt(selected);
//     if (!block || block.type !== 'columns') return;
//     updateAt(selected, { columns: block.columns.map((c) => (c.id === colId ? { ...c, ...patch } : c)) });
//   };

//   // ---- image upload for the currently selected image block ----
// //   const handleImageUploadForSelected = async (e) => {
// //     const file = e.target.files?.[0];
// //     if (!file || !selected) return;
// //     setUploading(true);
// //     try {
// //       const formData = new FormData();
// //       formData.append('image', file);
// //       const res = await axios.post(`${Url}/blog/upload-canvas-image`, formData);
// //       updateAt(selected, { src: res.data.key });
// //       toast.success('Image add ho gayi');
// //     } catch (err) {
// //       toast.error('Image upload fail ho gaya');
// //     } finally {
// //       setUploading(false);
// //       e.target.value = '';
// //     }
// //   };




//   // ---- image upload for the currently selected image block ----
//   const handleImageUploadForSelected = async (e) => {
//     const file = e.target.files?.[0];
//     if (!file || !selected) return;

//     // ⭐ FIX — choose karte hi local blob preview turant dikhao
//     const localPreviewUrl = URL.createObjectURL(file);
//     updateAt(selected, { src: localPreviewUrl, isUploading: true });

//     setUploading(true);
//     try {
//       const formData = new FormData();
//       formData.append('image', file);
//       const res = await axios.post(`${Url}/blog/upload-canvas-image`, formData);

//       // ⭐ upload complete hote hi real S3 key se replace, blob revoke karo (memory leak avoid)
//       updateAt(selected, { src: res.data.key, isUploading: false });
//       URL.revokeObjectURL(localPreviewUrl);

//       toast.success('Image add ho gayi');
//     } catch (err) {
//       updateAt(selected, { isUploading: false }); // ⭐ fail hone par bhi local preview rehne do, upload flag hata do
//       toast.error('Image upload fail ho gaya');
//     } finally {
//       setUploading(false);
//       e.target.value = '';
//     }
//   };

//   const applyPreset = (key) => {
//     setBlocks(PRESETS[key]());
//     setSelected(null);
//     setShowTemplates(false);
//   };

//   const handleApply = () => {
//     const payload = JSON.stringify({ width: canvasWidth, background: canvasBg, blocks });
//     onChange?.(payload);
//     toast.success('Template applied — form submit karne pe ye save ho jayega');
//   };

//   const selectedBlock = getBlockAt(selected);

//   return (
//     <div className="page-builder border rounded-3 overflow-hidden" onClick={() => setSelected(null)}>
//       {/* ADD toolbar */}
//       <div className="d-flex flex-wrap align-items-center gap-2 p-2 border-bottom bg-white" onClick={(e) => e.stopPropagation()}>
//         <span className="fw-semibold small text-muted me-1">ADD:</span>
//         {ADD_TYPES.map((t) => (
//           <button key={t} type="button" className="btn btn-sm btn-outline-secondary" onClick={() => addBlock(t)}>
//             {TYPE_LABELS[t]}
//           </button>
//         ))}
//       </div>

//       {/* SETTINGS bar */}
//       <div className="d-flex flex-wrap align-items-center gap-2 p-2 border-bottom bg-light" onClick={(e) => e.stopPropagation()}>
//         <span className="fw-semibold small text-muted">SETTINGS:</span>
//         <label className="small mb-0">BG:</label>
//         <input type="color" value={canvasBg} onChange={(e) => setCanvasBg(e.target.value)} />
//         <label className="small mb-0 ms-2">Width:</label>
//         <select className="form-select form-select-sm" style={{ width: 160 }} value={canvasWidth} onChange={(e) => setCanvasWidth(Number(e.target.value))}>
//           <option value={600}>600px — Standard</option>
//           <option value={700}>700px — Wide</option>
//           <option value={800}>800px — Extra Wide</option>
//           <option value={1000}>1000px — Full</option>
//         </select>

//         <div className="ms-auto d-flex gap-2 position-relative">
//           <button type="button" className="btn btn-sm btn-outline-dark" onClick={() => setShowTemplates((s) => !s)}>
//             Templates
//           </button>
//           {showTemplates && (
//             <div className="border rounded bg-white shadow-sm p-1" style={{ position: 'absolute', top: '110%', right: 0, zIndex: 20, width: 180 }}>
//               <button type="button" className="btn btn-sm btn-light w-100 text-start" onClick={() => applyPreset('blank')}>
//                 Blank
//               </button>
//               <button type="button" className="btn btn-sm btn-light w-100 text-start" onClick={() => applyPreset('textImage')}>
//                 Text + Image
//               </button>
//               <button type="button" className="btn btn-sm btn-light w-100 text-start" onClick={() => applyPreset('bannerText')}>
//                 Banner + Text
//               </button>
//             </div>
//           )}
//           <button type="button" className={`btn btn-sm ${!previewMode ? 'btn-dark' : 'btn-outline-dark'}`} onClick={() => setPreviewMode(false)}>
//             Edit
//           </button>
//           <button type="button" className={`btn btn-sm ${previewMode ? 'btn-dark' : 'btn-outline-dark'}`} onClick={() => setPreviewMode(true)}>
//             Preview
//           </button>
//           <button type="button" className="btn btn-sm btn-primary" onClick={handleApply}>
//             ✓ Apply Template
//           </button>
//         </div>
//       </div>

//       {/* Canvas + settings panel */}
//       <div className="d-flex" style={{ minHeight: 420 }}>
//         <div className="flex-grow-1 p-3" style={{ background: '#e9edf1', overflow: 'auto' }} onClick={() => setSelected(null)}>
//           <div style={{ width: canvasWidth, maxWidth: '100%', margin: '0 auto', background: canvasBg, minHeight: 380 }} onClick={(e) => e.stopPropagation()}>
//             {blocks.length === 0 && <p className="text-center text-muted py-5">Upar se "ADD" karke blocks daalo</p>}

//             {previewMode
//               ? blocks.map((b) => <BlockContent key={b.id} block={b} />)
//               : blocks.map((block, idx) => (
//                   <BlockNode
//                     key={block.id}
//                     block={block}
//                     path={{ top: true, id: block.id }}
//                     selected={selected}
//                     canMoveUp={idx > 0}
//                     canMoveDown={idx < blocks.length - 1}
//                     onSelect={setSelected}
//                     onMove={moveAt}
//                     onDuplicate={duplicateAt}
//                     onDelete={removeAt}
//                     onAddChild={(colPath, type) => addBlock(type, colPath)}
//                   />
//                 ))}
//           </div>
//         </div>

//         {!previewMode && (
//           <div className="border-start p-3 bg-white" style={{ width: 320, overflow: 'auto' }} onClick={(e) => e.stopPropagation()}>
//             <SettingsPanel
//               block={selectedBlock}
//               onUpdate={(patch) => updateAt(selected, patch)}
//               onAddColumn={addColumn}
//               onRemoveColumn={removeColumn}
//               onUpdateColumn={updateColumnProp}
//               onImageUpload={handleImageUploadForSelected}
//               uploading={uploading}
//             />
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default PageBuilder;









// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { toast } from 'react-toastify';
// import { Url } from '../url/url'; // 👈 apne project ke hisab se path adjust kar lena
// import { ADD_TYPES, CHILD_ADD_TYPES, TYPE_LABELS, defaultBlock, genId, BlockContent } from './PageBuilderShared';

// // ---- small helpers -------------------------------------------------------

// const AddChildPicker = ({ label, onPick }) => {
//   const [open, setOpen] = useState(false);
//   return (
//     <div style={{ position: 'relative' }} onClick={(e) => e.stopPropagation()}>
//       <button type="button" className="btn btn-sm btn-outline-primary w-100 my-1" onClick={() => setOpen((o) => !o)}>
//         {label}
//       </button>
//       {open && (
//         <div className="border rounded bg-white shadow-sm p-1" style={{ position: 'absolute', zIndex: 20, width: '100%' }}>
//           {CHILD_ADD_TYPES.map((t) => (
//             <button
//               key={t}
//               type="button"
//               className="btn btn-sm btn-light w-100 text-start"
//               onClick={() => {
//                 onPick(t);
//                 setOpen(false);
//               }}
//             >
//               {TYPE_LABELS[t]}
//             </button>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };

// const AlignPicker = ({ value, onChange }) => (
//   <>
//     <label className="small d-block mt-2">Align</label>
//     <select className="form-select form-select-sm mb-2" value={value} onChange={(e) => onChange(e.target.value)}>
//       <option value="left">Left</option>
//       <option value="center">Center</option>
//       <option value="right">Right</option>
//     </select>
//   </>
// );

// const samePath = (a, b) =>
//   a && b && a.id === b.id && !!a.top === !!b.top && a.parentId === b.parentId && a.colId === b.colId;

// // ---- one block in the canvas (editable) ----------------------------------

// const BlockNode = ({ block, path, selected, canMoveUp, canMoveDown, onSelect, onMove, onDuplicate, onDelete, onAddChild }) => {
//   const [hover, setHover] = useState(false);
//   const isSelected = samePath(selected, path);

//   return (
//     <div
//       onMouseEnter={() => setHover(true)}
//       onMouseLeave={() => setHover(false)}
//       onClick={(e) => {
//         e.stopPropagation();
//         onSelect(path);
//       }}
//       style={{
//         position: 'relative',
//         outline: isSelected ? '2px solid #3b82f6' : hover ? '2px dashed #93c5fd' : '1px solid transparent',
//         cursor: 'pointer',
//         marginBottom: 2,
//       }}
//     >
//       {(hover || isSelected) && (
//         <div className="d-flex gap-1" style={{ position: 'absolute', top: 2, right: 2, zIndex: 6 }} onClick={(e) => e.stopPropagation()}>
//           <button type="button" className="btn btn-dark py-0 px-1" style={{ fontSize: 11 }} disabled={!canMoveUp} onClick={() => onMove(path, -1)}>
//             ↑
//           </button>
//           <button type="button" className="btn btn-dark py-0 px-1" style={{ fontSize: 11 }} disabled={!canMoveDown} onClick={() => onMove(path, 1)}>
//             ↓
//           </button>
//           <button type="button" className="btn btn-success py-0 px-1" style={{ fontSize: 11 }} onClick={() => onDuplicate(path)}>
//             ⧉
//           </button>
//           <button type="button" className="btn btn-danger py-0 px-1" style={{ fontSize: 11 }} onClick={() => onDelete(path)}>
//             ✕
//           </button>
//         </div>
//       )}

//       {block.type === 'columns' ? (
//         <div style={{ display: 'flex', gap: block.gap, background: block.rowBackground, padding: 8 }}>
//           {block.columns.map((col, ci) => (
//             <div key={col.id} style={{ width: `${col.width}%`, background: col.background, minHeight: 60, border: '1px dashed #d1d5db', padding: 4 }}>
//               {col.blocks.map((child, idx) => (
//                 <BlockNode
//                   key={child.id}
//                   block={child}
//                   path={{ top: false, parentId: block.id, colId: col.id, id: child.id }}
//                   selected={selected}
//                   canMoveUp={idx > 0}
//                   canMoveDown={idx < col.blocks.length - 1}
//                   onSelect={onSelect}
//                   onMove={onMove}
//                   onDuplicate={onDuplicate}
//                   onDelete={onDelete}
//                   onAddChild={onAddChild}
//                 />
//               ))}
//               <AddChildPicker
//                 label={col.blocks.length === 0 ? `+ Add to Col ${ci + 1}` : '+ Add block'}
//                 onPick={(type) => onAddChild({ parentId: block.id, colId: col.id }, type)}
//               />
//             </div>
//           ))}
//         </div>
//       ) : (
//         <BlockContent block={block} />
//       )}
//     </div>
//   );
// };

// // ---- right-side settings panel -------------------------------------------

// const SettingsPanel = ({ block, onUpdate, onAddColumn, onRemoveColumn, onUpdateColumn, onImageUpload, uploading }) => {
//   if (!block) return <p className="text-muted small">Kisi block pe click karo settings dekhne ke liye</p>;

//   switch (block.type) {
//     case 'banner':
//       return (
//         <>
//           <h6 className="fw-bold">BANNER SETTINGS</h6>
//           <label className="small">Text</label>
//           <textarea className="form-control form-control-sm mb-2" value={block.text} onChange={(e) => onUpdate({ text: e.target.value })} />
//           <label className="small">Background</label>
//           <input type="color" className="form-control form-control-color mb-2" value={block.bgColor} onChange={(e) => onUpdate({ bgColor: e.target.value })} />
//           <label className="small">Text Color</label>
//           <input type="color" className="form-control form-control-color mb-2" value={block.textColor} onChange={(e) => onUpdate({ textColor: e.target.value })} />
//           <label className="small">Height (px)</label>
//           <input type="number" className="form-control form-control-sm mb-2" value={block.height} onChange={(e) => onUpdate({ height: Number(e.target.value) })} />
//           <AlignPicker value={block.align} onChange={(v) => onUpdate({ align: v })} />
//         </>
//       );

//     case 'heading':
//       return (
//         <>
//           <h6 className="fw-bold">HEADING SETTINGS</h6>
//           <label className="small">Text</label>
//           <input className="form-control form-control-sm mb-2" value={block.text} onChange={(e) => onUpdate({ text: e.target.value })} />
//           <label className="small">Font size</label>
//           <input type="number" className="form-control form-control-sm mb-2" value={block.fontSize} onChange={(e) => onUpdate({ fontSize: Number(e.target.value) })} />
//           <label className="small">Color</label>
//           <input type="color" className="form-control form-control-color mb-2" value={block.color} onChange={(e) => onUpdate({ color: e.target.value })} />
//           <AlignPicker value={block.align} onChange={(v) => onUpdate({ align: v })} />
//         </>
//       );

//     case 'text':
//       return (
//         <>
//           <h6 className="fw-bold">TEXT SETTINGS</h6>
//           <label className="small">Content</label>
//           <textarea rows={5} className="form-control form-control-sm mb-1" value={block.content} onChange={(e) => onUpdate({ content: e.target.value })} />
//           <p className="text-muted small mb-2">
//             {/* ⭐ NEW — link banane ka tarika batane wala helper text */}
//             Link banane ke liye is format mein likho: <code>[yahan click karo](https://example.com)</code>
//           </p>
//           <label className="small">Font size</label>
//           <input type="number" className="form-control form-control-sm mb-2" value={block.fontSize} onChange={(e) => onUpdate({ fontSize: Number(e.target.value) })} />
//           <label className="small">Color</label>
//           <input type="color" className="form-control form-control-color mb-2" value={block.color} onChange={(e) => onUpdate({ color: e.target.value })} />
//           <AlignPicker value={block.align} onChange={(v) => onUpdate({ align: v })} />
//         </>
//       );

//     case 'image':
//       return (
//         <>
//           <h6 className="fw-bold">IMAGE SETTINGS</h6>
//           <label className="small">Upload</label>
//           <input type="file" accept="image/*" className="form-control form-control-sm mb-2" disabled={uploading} onChange={onImageUpload} />
//           {uploading && <p className="small text-muted">Uploading...</p>}
//           <label className="small">Alt text</label>
//           <input className="form-control form-control-sm mb-2" value={block.alt} onChange={(e) => onUpdate({ alt: e.target.value })} />
//           <label className="small">Width (%)</label>
//           <input type="range" min={20} max={100} className="form-range mb-2" value={block.width} onChange={(e) => onUpdate({ width: Number(e.target.value) })} />
//           <AlignPicker value={block.align} onChange={(v) => onUpdate({ align: v })} />
//         </>
//       );

//     case 'button':
//       return (
//         <>
//           <h6 className="fw-bold">BUTTON SETTINGS</h6>
//           <label className="small">Label</label>
//           <input className="form-control form-control-sm mb-2" value={block.label} onChange={(e) => onUpdate({ label: e.target.value })} />
//           <label className="small">Link URL</label>
//           <input className="form-control form-control-sm mb-2" value={block.url} onChange={(e) => onUpdate({ url: e.target.value })} />
//           <label className="small">Background</label>
//           <input type="color" className="form-control form-control-color mb-2" value={block.bgColor} onChange={(e) => onUpdate({ bgColor: e.target.value })} />
//           <label className="small">Text Color</label>
//           <input type="color" className="form-control form-control-color mb-2" value={block.textColor} onChange={(e) => onUpdate({ textColor: e.target.value })} />
//           <AlignPicker value={block.align} onChange={(v) => onUpdate({ align: v })} />
//         </>
//       );

//     case 'divider':
//       return (
//         <>
//           <h6 className="fw-bold">DIVIDER SETTINGS</h6>
//           <label className="small">Color</label>
//           <input type="color" className="form-control form-control-color mb-2" value={block.color} onChange={(e) => onUpdate({ color: e.target.value })} />
//           <label className="small">Thickness (px)</label>
//           <input type="number" className="form-control form-control-sm mb-2" value={block.thickness} onChange={(e) => onUpdate({ thickness: Number(e.target.value) })} />
//         </>
//       );

//     case 'spacer':
//       return (
//         <>
//           <h6 className="fw-bold">SPACER SETTINGS</h6>
//           <label className="small">Height (px)</label>
//           <input type="number" className="form-control form-control-sm mb-2" value={block.height} onChange={(e) => onUpdate({ height: Number(e.target.value) })} />
//         </>
//       );

//     case 'social':
//       return (
//         <>
//           <h6 className="fw-bold">SOCIAL SETTINGS</h6>
//           {block.links.map((l, i) => (
//             <div key={i} className="d-flex gap-1 mb-1">
//               <input
//                 className="form-control form-control-sm"
//                 value={l.platform}
//                 onChange={(e) => {
//                   const links = [...block.links];
//                   links[i] = { ...links[i], platform: e.target.value };
//                   onUpdate({ links });
//                 }}
//               />
//               <input
//                 className="form-control form-control-sm"
//                 value={l.url}
//                 onChange={(e) => {
//                   const links = [...block.links];
//                   links[i] = { ...links[i], url: e.target.value };
//                   onUpdate({ links });
//                 }}
//               />
//             </div>
//           ))}
//           <button
//             type="button"
//             className="btn btn-sm btn-outline-primary mb-2"
//             onClick={() => onUpdate({ links: [...block.links, { platform: 'New', url: '#' }] })}
//           >
//             + Add link
//           </button>
//           <AlignPicker value={block.align} onChange={(v) => onUpdate({ align: v })} />
//         </>
//       );

//     case 'footer':
//       return (
//         <>
//           <h6 className="fw-bold">FOOTER SETTINGS</h6>
//           <label className="small">Text</label>
//           <input className="form-control form-control-sm mb-2" value={block.text} onChange={(e) => onUpdate({ text: e.target.value })} />
//           <label className="small">Background</label>
//           <input type="color" className="form-control form-control-color mb-2" value={block.bgColor} onChange={(e) => onUpdate({ bgColor: e.target.value })} />
//           <label className="small">Text Color</label>
//           <input type="color" className="form-control form-control-color mb-2" value={block.textColor} onChange={(e) => onUpdate({ textColor: e.target.value })} />
//         </>
//       );

//     case 'columns':
//       return (
//         <>
//           <h6 className="fw-bold">COLUMNS SETTINGS</h6>
//           <label className="small">Row Background</label>
//           <input
//             type="color"
//             className="form-control form-control-color mb-2"
//             value={block.rowBackground === 'transparent' ? '#ffffff' : block.rowBackground}
//             onChange={(e) => onUpdate({ rowBackground: e.target.value })}
//           />
//           <label className="small">Gap (px)</label>
//           <input type="number" className="form-control form-control-sm mb-3" value={block.gap} onChange={(e) => onUpdate({ gap: Number(e.target.value) })} />

//           <div className="d-flex justify-content-between align-items-center mb-2">
//             <span className="small fw-semibold text-muted">COLUMNS ({block.columns.length})</span>
//             <button type="button" className="btn btn-sm btn-primary" onClick={onAddColumn}>
//               + Add
//             </button>
//           </div>

//           {block.columns.map((col, i) => (
//             <div key={col.id} className="border rounded p-2 mb-2">
//               <div className="d-flex justify-content-between align-items-center mb-1">
//                 <span className="small fw-semibold">Column {i + 1}</span>
//                 {block.columns.length > 1 && (
//                   <button type="button" className="btn btn-sm btn-outline-danger py-0 px-1" onClick={() => onRemoveColumn(col.id)}>
//                     ✕
//                   </button>
//                 )}
//               </div>
//               <label className="small">Width (%)</label>
//               <input
//                 type="number"
//                 className="form-control form-control-sm mb-1"
//                 value={col.width}
//                 onChange={(e) => onUpdateColumn(col.id, { width: Number(e.target.value) })}
//               />
//               <label className="small">Background</label>
//               <input type="color" className="form-control form-control-color" value={col.background} onChange={(e) => onUpdateColumn(col.id, { background: e.target.value })} />
//             </div>
//           ))}
//         </>
//       );

//     default:
//       return null;
//   }
// };

// // ---- presets for the "Templates" dropdown --------------------------------

// const PRESETS = {
//   blank: () => [],
//   textImage: () => [defaultBlock('heading'), defaultBlock('text'), defaultBlock('image')],
//   bannerText: () => [defaultBlock('banner'), defaultBlock('text'), defaultBlock('button')],
// };

// // ---- main component --------------------------------------------------------

// /**
//  * Block-based page builder (email-builder style) for the blog description page.
//  *
//  * Props:
//  *  - initialData: saved JSON string (optional, edit-blog case)
//  *  - onChange(jsonString): parent stores this in formData.builderData
//  */
// const PageBuilder = ({ initialData, onChange }) => {
//   const [blocks, setBlocks] = useState([]);
//   const [canvasWidth, setCanvasWidth] = useState(600);
//   const [canvasBg, setCanvasBg] = useState('#f1f5f9');
//   const [selected, setSelected] = useState(null);
//   const [previewMode, setPreviewMode] = useState(false);
//   const [showTemplates, setShowTemplates] = useState(false);
//   const [uploading, setUploading] = useState(false);

//   useEffect(() => {
//     if (initialData) {
//       try {
//         const parsed = JSON.parse(initialData);
//         setBlocks(parsed.blocks || []);
//         setCanvasWidth(parsed.width || 600);
//         setCanvasBg(parsed.background || '#f1f5f9');
//       } catch (e) {
//         // purana plain description hoga, ignore karo
//       }
//     }
//   }, [initialData]);

//   // ---- tree helpers ----
//   const getBlockAt = (path) => {
//     if (!path) return null;
//     if (path.top) return blocks.find((b) => b.id === path.id);
//     const parent = blocks.find((b) => b.id === path.parentId);
//     const col = parent?.columns.find((c) => c.id === path.colId);
//     return col?.blocks.find((b) => b.id === path.id);
//   };

//   const updateAt = (path, patch) => {
//     setBlocks((prev) => {
//       if (path.top) return prev.map((b) => (b.id === path.id ? { ...b, ...patch } : b));
//       return prev.map((b) => {
//         if (b.id !== path.parentId) return b;
//         return {
//           ...b,
//           columns: b.columns.map((c) => (c.id !== path.colId ? c : { ...c, blocks: c.blocks.map((ch) => (ch.id === path.id ? { ...ch, ...patch } : ch)) })),
//         };
//       });
//     });
//   };

//   const removeAt = (path) => {
//     setBlocks((prev) => {
//       if (path.top) return prev.filter((b) => b.id !== path.id);
//       return prev.map((b) => {
//         if (b.id !== path.parentId) return b;
//         return { ...b, columns: b.columns.map((c) => (c.id !== path.colId ? c : { ...c, blocks: c.blocks.filter((ch) => ch.id !== path.id) })) };
//       });
//     });
//     setSelected(null);
//   };

//   const moveAt = (path, dir) => {
//     setBlocks((prev) => {
//       if (path.top) {
//         const idx = prev.findIndex((b) => b.id === path.id);
//         const newIdx = idx + dir;
//         if (newIdx < 0 || newIdx >= prev.length) return prev;
//         const arr = [...prev];
//         [arr[idx], arr[newIdx]] = [arr[newIdx], arr[idx]];
//         return arr;
//       }
//       return prev.map((b) => {
//         if (b.id !== path.parentId) return b;
//         return {
//           ...b,
//           columns: b.columns.map((c) => {
//             if (c.id !== path.colId) return c;
//             const idx = c.blocks.findIndex((ch) => ch.id === path.id);
//             const newIdx = idx + dir;
//             if (newIdx < 0 || newIdx >= c.blocks.length) return c;
//             const arr = [...c.blocks];
//             [arr[idx], arr[newIdx]] = [arr[newIdx], arr[idx]];
//             return { ...c, blocks: arr };
//           }),
//         };
//       });
//     });
//   };

//   const duplicateAt = (path) => {
//     const block = getBlockAt(path);
//     if (!block) return;
//     const clone = { ...block, id: genId() };
//     if (path.top) {
//       setBlocks((prev) => {
//         const idx = prev.findIndex((b) => b.id === path.id);
//         const arr = [...prev];
//         arr.splice(idx + 1, 0, clone);
//         return arr;
//       });
//     } else {
//       setBlocks((prev) =>
//         prev.map((b) => {
//           if (b.id !== path.parentId) return b;
//           return {
//             ...b,
//             columns: b.columns.map((c) => {
//               if (c.id !== path.colId) return c;
//               const idx = c.blocks.findIndex((ch) => ch.id === path.id);
//               const arr = [...c.blocks];
//               arr.splice(idx + 1, 0, clone);
//               return { ...c, blocks: arr };
//             }),
//           };
//         })
//       );
//     }
//   };

//   const addBlock = (type, colPath = null) => {
//     const block = defaultBlock(type);
//     if (!colPath) {
//       setBlocks((prev) => [...prev, block]);
//       setSelected({ top: true, id: block.id });
//     } else {
//       setBlocks((prev) =>
//         prev.map((b) => {
//           if (b.id !== colPath.parentId) return b;
//           return { ...b, columns: b.columns.map((c) => (c.id === colPath.colId ? { ...c, blocks: [...c.blocks, block] } : c)) };
//         })
//       );
//       setSelected({ top: false, parentId: colPath.parentId, colId: colPath.colId, id: block.id });
//     }
//   };

//   // ---- columns-specific ----
//   const addColumn = () => {
//     if (!selected) return;
//     const block = getBlockAt(selected);
//     if (!block || block.type !== 'columns') return;
//     const newCol = { id: genId(), width: 30, background: '#ffffff', blocks: [] };
//     const cols = [...block.columns, newCol];
//     const evenWidth = Math.floor(100 / cols.length);
//     updateAt(selected, { columns: cols.map((c) => ({ ...c, width: evenWidth })) });
//   };

//   const removeColumn = (colId) => {
//     if (!selected) return;
//     const block = getBlockAt(selected);
//     if (!block || block.type !== 'columns') return;
//     const cols = block.columns.filter((c) => c.id !== colId);
//     const evenWidth = Math.floor(100 / Math.max(cols.length, 1));
//     updateAt(selected, { columns: cols.map((c) => ({ ...c, width: evenWidth })) });
//   };

//   const updateColumnProp = (colId, patch) => {
//     if (!selected) return;
//     const block = getBlockAt(selected);
//     if (!block || block.type !== 'columns') return;
//     updateAt(selected, { columns: block.columns.map((c) => (c.id === colId ? { ...c, ...patch } : c)) });
//   };

//   // ---- image upload for the currently selected image block ----
//   const handleImageUploadForSelected = async (e) => {
//     const file = e.target.files?.[0];
//     if (!file || !selected) return;

//     // choose karte hi turant local blob preview dikhao
//     const localPreviewUrl = URL.createObjectURL(file);
//     updateAt(selected, { src: localPreviewUrl, isUploading: true });

//     setUploading(true);
//     try {
//       const formData = new FormData();
//       formData.append('image', file);
//       const res = await axios.post(`${Url}/blog/upload-canvas-image`, formData);

//       // upload complete hote hi real S3 key se replace, blob revoke karo
//       updateAt(selected, { src: res.data.key, isUploading: false });
//       URL.revokeObjectURL(localPreviewUrl);

//       toast.success('Image add ho gayi');
//     } catch (err) {
//       updateAt(selected, { isUploading: false });
//       toast.error('Image upload fail ho gaya');
//     } finally {
//       setUploading(false);
//       e.target.value = '';
//     }
//   };

//   const applyPreset = (key) => {
//     setBlocks(PRESETS[key]());
//     setSelected(null);
//     setShowTemplates(false);
//   };

//   const handleApply = () => {
//     const payload = JSON.stringify({ width: canvasWidth, background: canvasBg, blocks });
//     onChange?.(payload);
//     toast.success('Template applied — form submit karne pe ye save ho jayega');
//   };

//   const selectedBlock = getBlockAt(selected);

//   return (
//     <div className="page-builder border rounded-3 overflow-hidden" onClick={() => setSelected(null)}>
//       {/* ADD toolbar */}
//       <div className="d-flex flex-wrap align-items-center gap-2 p-2 border-bottom bg-white" onClick={(e) => e.stopPropagation()}>
//         <span className="fw-semibold small text-muted me-1">ADD:</span>
//         {ADD_TYPES.map((t) => (
//           <button key={t} type="button" className="btn btn-sm btn-outline-secondary" onClick={() => addBlock(t)}>
//             {TYPE_LABELS[t]}
//           </button>
//         ))}
//       </div>

//       {/* SETTINGS bar */}
//       <div className="d-flex flex-wrap align-items-center gap-2 p-2 border-bottom bg-light" onClick={(e) => e.stopPropagation()}>
//         <span className="fw-semibold small text-muted">SETTINGS:</span>
//         <label className="small mb-0">BG:</label>
//         <input type="color" value={canvasBg} onChange={(e) => setCanvasBg(e.target.value)} />
//         <label className="small mb-0 ms-2">Width:</label>
//         <select className="form-select form-select-sm" style={{ width: 160 }} value={canvasWidth} onChange={(e) => setCanvasWidth(Number(e.target.value))}>
//           <option value={600}>600px — Standard</option>
//           <option value={700}>700px — Wide</option>
//           <option value={800}>800px — Extra Wide</option>
//           <option value={1000}>1000px — Full</option>
//         </select>

//         <div className="ms-auto d-flex gap-2 position-relative">
//           <button type="button" className="btn btn-sm btn-outline-dark" onClick={() => setShowTemplates((s) => !s)}>
//             Templates
//           </button>
//           {showTemplates && (
//             <div className="border rounded bg-white shadow-sm p-1" style={{ position: 'absolute', top: '110%', right: 0, zIndex: 20, width: 180 }}>
//               <button type="button" className="btn btn-sm btn-light w-100 text-start" onClick={() => applyPreset('blank')}>
//                 Blank
//               </button>
//               <button type="button" className="btn btn-sm btn-light w-100 text-start" onClick={() => applyPreset('textImage')}>
//                 Text + Image
//               </button>
//               <button type="button" className="btn btn-sm btn-light w-100 text-start" onClick={() => applyPreset('bannerText')}>
//                 Banner + Text
//               </button>
//             </div>
//           )}
//           <button type="button" className={`btn btn-sm ${!previewMode ? 'btn-dark' : 'btn-outline-dark'}`} onClick={() => setPreviewMode(false)}>
//             Edit
//           </button>
//           <button type="button" className={`btn btn-sm ${previewMode ? 'btn-dark' : 'btn-outline-dark'}`} onClick={() => setPreviewMode(true)}>
//             Preview
//           </button>
//           <button type="button" className="btn btn-sm btn-primary" onClick={handleApply}>
//             ✓ Apply Template
//           </button>
//         </div>
//       </div>

//       {/* Canvas + settings panel */}
//       <div className="d-flex" style={{ minHeight: 420 }}>
//         <div className="flex-grow-1 p-3" style={{ background: '#e9edf1', overflow: 'auto' }} onClick={() => setSelected(null)}>
//           <div style={{ width: canvasWidth, maxWidth: '100%', margin: '0 auto', background: canvasBg, minHeight: 380 }} onClick={(e) => e.stopPropagation()}>
//             {blocks.length === 0 && <p className="text-center text-muted py-5">Upar se "ADD" karke blocks daalo</p>}

//             {previewMode
//               ? blocks.map((b) => <BlockContent key={b.id} block={b} />)
//               : blocks.map((block, idx) => (
//                   <BlockNode
//                     key={block.id}
//                     block={block}
//                     path={{ top: true, id: block.id }}
//                     selected={selected}
//                     canMoveUp={idx > 0}
//                     canMoveDown={idx < blocks.length - 1}
//                     onSelect={setSelected}
//                     onMove={moveAt}
//                     onDuplicate={duplicateAt}
//                     onDelete={removeAt}
//                     onAddChild={(colPath, type) => addBlock(type, colPath)}
//                   />
//                 ))}
//           </div>
//         </div>

//         {!previewMode && (
//           <div className="border-start p-3 bg-white" style={{ width: 320, overflow: 'auto' }} onClick={(e) => e.stopPropagation()}>
//             <SettingsPanel
//               block={selectedBlock}
//               onUpdate={(patch) => updateAt(selected, patch)}
//               onAddColumn={addColumn}
//               onRemoveColumn={removeColumn}
//               onUpdateColumn={updateColumnProp}
//               onImageUpload={handleImageUploadForSelected}
//               uploading={uploading}
//             />
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default PageBuilder;














import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { Url } from '../url/url'; // adjust this path according to your project
import { ADD_TYPES, CHILD_ADD_TYPES, TYPE_LABELS, defaultBlock, genId, BlockContent } from './PageBuilderShared';

// ---- small helpers -------------------------------------------------------

const AddChildPicker = ({ label, onPick }) => {
  const [open, setOpen] = useState(false);
  return (
    <div style={{ position: 'relative' }} onClick={(e) => e.stopPropagation()}>
      <button type="button" className="btn btn-sm btn-outline-primary w-100 my-1" onClick={() => setOpen((o) => !o)}>
        {label}
      </button>
      {open && (
        <div className="border rounded bg-white shadow-sm p-1" style={{ position: 'absolute', zIndex: 20, width: '100%' }}>
          {CHILD_ADD_TYPES.map((t) => (
            <button
              key={t}
              type="button"
              className="btn btn-sm btn-light w-100 text-start"
              onClick={() => {
                onPick(t);
                setOpen(false);
              }}
            >
              {TYPE_LABELS[t]}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

const AlignPicker = ({ value, onChange }) => (
  <>
    <label className="small d-block mt-2">Align</label>
    <select className="form-select form-select-sm mb-2" value={value} onChange={(e) => onChange(e.target.value)}>
      <option value="left">Left</option>
      <option value="center">Center</option>
      <option value="right">Right</option>
    </select>
  </>
);

const samePath = (a, b) =>
  a && b && a.id === b.id && !!a.top === !!b.top && a.parentId === b.parentId && a.colId === b.colId;

// ---- one block in the canvas (editable) ----------------------------------

const BlockNode = ({ block, path, selected, canMoveUp, canMoveDown, onSelect, onMove, onDuplicate, onDelete, onAddChild }) => {
  const [hover, setHover] = useState(false);
  const isSelected = samePath(selected, path);

  return (
    <div
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onClick={(e) => {
        e.stopPropagation();
        onSelect(path);
      }}
      style={{
        position: 'relative',
        outline: isSelected ? '2px solid #3b82f6' : hover ? '2px dashed #93c5fd' : '1px solid transparent',
        cursor: 'pointer',
        marginBottom: 2,
      }}
    >
      {(hover || isSelected) && (
        <div className="d-flex gap-1" style={{ position: 'absolute', top: 2, right: 2, zIndex: 6 }} onClick={(e) => e.stopPropagation()}>
          <button type="button" className="btn btn-dark py-0 px-1" style={{ fontSize: 11 }} disabled={!canMoveUp} onClick={() => onMove(path, -1)}>
            ↑
          </button>
          <button type="button" className="btn btn-dark py-0 px-1" style={{ fontSize: 11 }} disabled={!canMoveDown} onClick={() => onMove(path, 1)}>
            ↓
          </button>
          <button type="button" className="btn btn-success py-0 px-1" style={{ fontSize: 11 }} onClick={() => onDuplicate(path)}>
            ⧉
          </button>
          <button type="button" className="btn btn-danger py-0 px-1" style={{ fontSize: 11 }} onClick={() => onDelete(path)}>
            ✕
          </button>
        </div>
      )}

      {block.type === 'columns' ? (
        <div style={{ display: 'flex', gap: block.gap, background: block.rowBackground, padding: 8 }}>
          {block.columns.map((col, ci) => (
            <div key={col.id} style={{ width: `${col.width}%`, background: col.background, minHeight: 60, border: '1px dashed #d1d5db', padding: 4 }}>
              {col.blocks.map((child, idx) => (
                <BlockNode
                  key={child.id}
                  block={child}
                  path={{ top: false, parentId: block.id, colId: col.id, id: child.id }}
                  selected={selected}
                  canMoveUp={idx > 0}
                  canMoveDown={idx < col.blocks.length - 1}
                  onSelect={onSelect}
                  onMove={onMove}
                  onDuplicate={onDuplicate}
                  onDelete={onDelete}
                  onAddChild={onAddChild}
                />
              ))}
              <AddChildPicker
                label={col.blocks.length === 0 ? `+ Add to Col ${ci + 1}` : '+ Add block'}
                onPick={(type) => onAddChild({ parentId: block.id, colId: col.id }, type)}
              />
            </div>
          ))}
        </div>
      ) : (
        <BlockContent block={block} />
      )}
    </div>
  );
};

// ---- right-side settings panel -------------------------------------------

const SettingsPanel = ({ block, onUpdate, onAddColumn, onRemoveColumn, onUpdateColumn, onImageUpload, uploading }) => {
  if (!block) return <p className="text-muted small">Click on a block to see its settings</p>;

  switch (block.type) {
    case 'banner':
      return (
        <>
          <h6 className="fw-bold">BANNER SETTINGS</h6>
          <label className="small">Text</label>
          <textarea className="form-control form-control-sm mb-2" value={block.text} onChange={(e) => onUpdate({ text: e.target.value })} />
          <label className="small">Background</label>
          <input type="color" className="form-control form-control-color mb-2" value={block.bgColor} onChange={(e) => onUpdate({ bgColor: e.target.value })} />
          <label className="small">Text Color</label>
          <input type="color" className="form-control form-control-color mb-2" value={block.textColor} onChange={(e) => onUpdate({ textColor: e.target.value })} />
          <label className="small">Height (px)</label>
          <input type="number" className="form-control form-control-sm mb-2" value={block.height} onChange={(e) => onUpdate({ height: Number(e.target.value) })} />
          <AlignPicker value={block.align} onChange={(v) => onUpdate({ align: v })} />
        </>
      );

    case 'heading':
      return (
        <>
          <h6 className="fw-bold">HEADING SETTINGS</h6>
          <label className="small">Text</label>
          <input className="form-control form-control-sm mb-2" value={block.text} onChange={(e) => onUpdate({ text: e.target.value })} />
          <label className="small">Font size</label>
          <input type="number" className="form-control form-control-sm mb-2" value={block.fontSize} onChange={(e) => onUpdate({ fontSize: Number(e.target.value) })} />
          <label className="small">Color</label>
          <input type="color" className="form-control form-control-color mb-2" value={block.color} onChange={(e) => onUpdate({ color: e.target.value })} />
          <AlignPicker value={block.align} onChange={(v) => onUpdate({ align: v })} />
        </>
      );

    case 'text':
      return (
        <>
          <h6 className="fw-bold">TEXT SETTINGS</h6>
          <label className="small">Content</label>
          <textarea rows={5} className="form-control form-control-sm mb-1" value={block.content} onChange={(e) => onUpdate({ content: e.target.value })} />
          <p className="text-muted small mb-2">
            To create a link, use this format: <code>[click here](https://example.com)</code>
          </p>
          <label className="small">Font size</label>
          <input type="number" className="form-control form-control-sm mb-2" value={block.fontSize} onChange={(e) => onUpdate({ fontSize: Number(e.target.value) })} />
          <label className="small">Color</label>
          <input type="color" className="form-control form-control-color mb-2" value={block.color} onChange={(e) => onUpdate({ color: e.target.value })} />
          <AlignPicker value={block.align} onChange={(v) => onUpdate({ align: v })} />
        </>
      );

    case 'image':
      return (
        <>
          <h6 className="fw-bold">IMAGE SETTINGS</h6>
          <label className="small">Upload</label>
          <input type="file" accept="image/*" className="form-control form-control-sm mb-2" disabled={uploading} onChange={onImageUpload} />
          {uploading && <p className="small text-muted">Uploading...</p>}
          <label className="small">Alt text</label>
          <input className="form-control form-control-sm mb-2" value={block.alt} onChange={(e) => onUpdate({ alt: e.target.value })} />
          <label className="small">Width (%)</label>
          <input type="range" min={20} max={100} className="form-range mb-2" value={block.width} onChange={(e) => onUpdate({ width: Number(e.target.value) })} />
          <AlignPicker value={block.align} onChange={(v) => onUpdate({ align: v })} />
        </>
      );

    case 'button':
      return (
        <>
          <h6 className="fw-bold">BUTTON SETTINGS</h6>
          <label className="small">Label</label>
          <input className="form-control form-control-sm mb-2" value={block.label} onChange={(e) => onUpdate({ label: e.target.value })} />
          <label className="small">Link URL</label>
          <input className="form-control form-control-sm mb-2" value={block.url} onChange={(e) => onUpdate({ url: e.target.value })} />
          <label className="small">Background</label>
          <input type="color" className="form-control form-control-color mb-2" value={block.bgColor} onChange={(e) => onUpdate({ bgColor: e.target.value })} />
          <label className="small">Text Color</label>
          <input type="color" className="form-control form-control-color mb-2" value={block.textColor} onChange={(e) => onUpdate({ textColor: e.target.value })} />
          <AlignPicker value={block.align} onChange={(v) => onUpdate({ align: v })} />
        </>
      );

    case 'divider':
      return (
        <>
          <h6 className="fw-bold">DIVIDER SETTINGS</h6>
          <label className="small">Color</label>
          <input type="color" className="form-control form-control-color mb-2" value={block.color} onChange={(e) => onUpdate({ color: e.target.value })} />
          <label className="small">Thickness (px)</label>
          <input type="number" className="form-control form-control-sm mb-2" value={block.thickness} onChange={(e) => onUpdate({ thickness: Number(e.target.value) })} />
        </>
      );

    case 'spacer':
      return (
        <>
          <h6 className="fw-bold">SPACER SETTINGS</h6>
          <label className="small">Height (px)</label>
          <input type="number" className="form-control form-control-sm mb-2" value={block.height} onChange={(e) => onUpdate({ height: Number(e.target.value) })} />
        </>
      );

    case 'social':
      return (
        <>
          <h6 className="fw-bold">SOCIAL SETTINGS</h6>
          {block.links.map((l, i) => (
            <div key={i} className="d-flex gap-1 mb-1">
              <input
                className="form-control form-control-sm"
                value={l.platform}
                onChange={(e) => {
                  const links = [...block.links];
                  links[i] = { ...links[i], platform: e.target.value };
                  onUpdate({ links });
                }}
              />
              <input
                className="form-control form-control-sm"
                value={l.url}
                onChange={(e) => {
                  const links = [...block.links];
                  links[i] = { ...links[i], url: e.target.value };
                  onUpdate({ links });
                }}
              />
            </div>
          ))}
          <button
            type="button"
            className="btn btn-sm btn-outline-primary mb-2"
            onClick={() => onUpdate({ links: [...block.links, { platform: 'New', url: '#' }] })}
          >
            + Add link
          </button>
          <AlignPicker value={block.align} onChange={(v) => onUpdate({ align: v })} />
        </>
      );

    case 'footer':
      return (
        <>
          <h6 className="fw-bold">FOOTER SETTINGS</h6>
          <label className="small">Text</label>
          <input className="form-control form-control-sm mb-2" value={block.text} onChange={(e) => onUpdate({ text: e.target.value })} />
          <label className="small">Background</label>
          <input type="color" className="form-control form-control-color mb-2" value={block.bgColor} onChange={(e) => onUpdate({ bgColor: e.target.value })} />
          <label className="small">Text Color</label>
          <input type="color" className="form-control form-control-color mb-2" value={block.textColor} onChange={(e) => onUpdate({ textColor: e.target.value })} />
        </>
      );

    case 'columns':
      return (
        <>
          <h6 className="fw-bold">COLUMNS SETTINGS</h6>
          <label className="small">Row Background</label>
          <input
            type="color"
            className="form-control form-control-color mb-2"
            value={block.rowBackground === 'transparent' ? '#ffffff' : block.rowBackground}
            onChange={(e) => onUpdate({ rowBackground: e.target.value })}
          />
          <label className="small">Gap (px)</label>
          <input type="number" className="form-control form-control-sm mb-3" value={block.gap} onChange={(e) => onUpdate({ gap: Number(e.target.value) })} />

          <div className="d-flex justify-content-between align-items-center mb-2">
            <span className="small fw-semibold text-muted">COLUMNS ({block.columns.length})</span>
            <button type="button" className="btn btn-sm btn-primary" onClick={onAddColumn}>
              + Add
            </button>
          </div>

          {block.columns.map((col, i) => (
            <div key={col.id} className="border rounded p-2 mb-2">
              <div className="d-flex justify-content-between align-items-center mb-1">
                <span className="small fw-semibold">Column {i + 1}</span>
                {block.columns.length > 1 && (
                  <button type="button" className="btn btn-sm btn-outline-danger py-0 px-1" onClick={() => onRemoveColumn(col.id)}>
                    ✕
                  </button>
                )}
              </div>
              <label className="small">Width (%)</label>
              <input
                type="number"
                className="form-control form-control-sm mb-1"
                value={col.width}
                onChange={(e) => onUpdateColumn(col.id, { width: Number(e.target.value) })}
              />
              <label className="small">Background</label>
              <input type="color" className="form-control form-control-color" value={col.background} onChange={(e) => onUpdateColumn(col.id, { background: e.target.value })} />
            </div>
          ))}
        </>
      );

    default:
      return null;
  }
};

// ---- presets for the "Templates" dropdown --------------------------------

const PRESETS = {
  blank: () => [],
  textImage: () => [defaultBlock('heading'), defaultBlock('text'), defaultBlock('image')],
  bannerText: () => [defaultBlock('banner'), defaultBlock('text'), defaultBlock('button')],
};

// ---- main component --------------------------------------------------------

/**
 * Block-based page builder (email-builder style) for the blog description page.
 *
 * Props:
 *  - initialData: saved JSON string (optional, edit-blog case)
 *  - onChange(jsonString): parent stores this in formData.builderData
 */
const PageBuilder = ({ initialData, onChange }) => {
  const [blocks, setBlocks] = useState([]);
  const [canvasWidth, setCanvasWidth] = useState(600);
  const [canvasBg, setCanvasBg] = useState('#f1f5f9');
  const [selected, setSelected] = useState(null);
  const [previewMode, setPreviewMode] = useState(false);
  const [showTemplates, setShowTemplates] = useState(false);
  const [uploading, setUploading] = useState(false);

  useEffect(() => {
    if (initialData) {
      try {
        const parsed = JSON.parse(initialData);
        setBlocks(parsed.blocks || []);
        setCanvasWidth(parsed.width || 600);
        setCanvasBg(parsed.background || '#f1f5f9');
      } catch (e) {
        // this will be an old plain-text description, ignore
      }
    }
  }, [initialData]);

  // ---- tree helpers ----
  const getBlockAt = (path) => {
    if (!path) return null;
    if (path.top) return blocks.find((b) => b.id === path.id);
    const parent = blocks.find((b) => b.id === path.parentId);
    const col = parent?.columns.find((c) => c.id === path.colId);
    return col?.blocks.find((b) => b.id === path.id);
  };

  const updateAt = (path, patch) => {
    setBlocks((prev) => {
      if (path.top) return prev.map((b) => (b.id === path.id ? { ...b, ...patch } : b));
      return prev.map((b) => {
        if (b.id !== path.parentId) return b;
        return {
          ...b,
          columns: b.columns.map((c) => (c.id !== path.colId ? c : { ...c, blocks: c.blocks.map((ch) => (ch.id === path.id ? { ...ch, ...patch } : ch)) })),
        };
      });
    });
  };

  const removeAt = (path) => {
    setBlocks((prev) => {
      if (path.top) return prev.filter((b) => b.id !== path.id);
      return prev.map((b) => {
        if (b.id !== path.parentId) return b;
        return { ...b, columns: b.columns.map((c) => (c.id !== path.colId ? c : { ...c, blocks: c.blocks.filter((ch) => ch.id !== path.id) })) };
      });
    });
    setSelected(null);
  };

  const moveAt = (path, dir) => {
    setBlocks((prev) => {
      if (path.top) {
        const idx = prev.findIndex((b) => b.id === path.id);
        const newIdx = idx + dir;
        if (newIdx < 0 || newIdx >= prev.length) return prev;
        const arr = [...prev];
        [arr[idx], arr[newIdx]] = [arr[newIdx], arr[idx]];
        return arr;
      }
      return prev.map((b) => {
        if (b.id !== path.parentId) return b;
        return {
          ...b,
          columns: b.columns.map((c) => {
            if (c.id !== path.colId) return c;
            const idx = c.blocks.findIndex((ch) => ch.id === path.id);
            const newIdx = idx + dir;
            if (newIdx < 0 || newIdx >= c.blocks.length) return c;
            const arr = [...c.blocks];
            [arr[idx], arr[newIdx]] = [arr[newIdx], arr[idx]];
            return { ...c, blocks: arr };
          }),
        };
      });
    });
  };

  const duplicateAt = (path) => {
    const block = getBlockAt(path);
    if (!block) return;
    const clone = { ...block, id: genId() };
    if (path.top) {
      setBlocks((prev) => {
        const idx = prev.findIndex((b) => b.id === path.id);
        const arr = [...prev];
        arr.splice(idx + 1, 0, clone);
        return arr;
      });
    } else {
      setBlocks((prev) =>
        prev.map((b) => {
          if (b.id !== path.parentId) return b;
          return {
            ...b,
            columns: b.columns.map((c) => {
              if (c.id !== path.colId) return c;
              const idx = c.blocks.findIndex((ch) => ch.id === path.id);
              const arr = [...c.blocks];
              arr.splice(idx + 1, 0, clone);
              return { ...c, blocks: arr };
            }),
          };
        })
      );
    }
  };

  const addBlock = (type, colPath = null) => {
    const block = defaultBlock(type);
    if (!colPath) {
      setBlocks((prev) => [...prev, block]);
      setSelected({ top: true, id: block.id });
    } else {
      setBlocks((prev) =>
        prev.map((b) => {
          if (b.id !== colPath.parentId) return b;
          return { ...b, columns: b.columns.map((c) => (c.id === colPath.colId ? { ...c, blocks: [...c.blocks, block] } : c)) };
        })
      );
      setSelected({ top: false, parentId: colPath.parentId, colId: colPath.colId, id: block.id });
    }
  };

  // ---- columns-specific ----
  const addColumn = () => {
    if (!selected) return;
    const block = getBlockAt(selected);
    if (!block || block.type !== 'columns') return;
    const newCol = { id: genId(), width: 30, background: '#ffffff', blocks: [] };
    const cols = [...block.columns, newCol];
    const evenWidth = Math.floor(100 / cols.length);
    updateAt(selected, { columns: cols.map((c) => ({ ...c, width: evenWidth })) });
  };

  const removeColumn = (colId) => {
    if (!selected) return;
    const block = getBlockAt(selected);
    if (!block || block.type !== 'columns') return;
    const cols = block.columns.filter((c) => c.id !== colId);
    const evenWidth = Math.floor(100 / Math.max(cols.length, 1));
    updateAt(selected, { columns: cols.map((c) => ({ ...c, width: evenWidth })) });
  };

  const updateColumnProp = (colId, patch) => {
    if (!selected) return;
    const block = getBlockAt(selected);
    if (!block || block.type !== 'columns') return;
    updateAt(selected, { columns: block.columns.map((c) => (c.id === colId ? { ...c, ...patch } : c)) });
  };

  // ---- image upload for the currently selected image block ----
  const handleImageUploadForSelected = async (e) => {
    const file = e.target.files?.[0];
    if (!file || !selected) return;

    // show a local blob preview immediately, before the upload finishes
    const localPreviewUrl = URL.createObjectURL(file);
    updateAt(selected, { src: localPreviewUrl, isUploading: true });

    setUploading(true);
    try {
      const formData = new FormData();
      formData.append('image', file);
      const res = await axios.post(`${Url}/blog/upload-canvas-image`, formData);

      // once the upload finishes, swap in the real S3 key and release the blob
      updateAt(selected, { src: res.data.key, isUploading: false });
      URL.revokeObjectURL(localPreviewUrl);

      toast.success('Image added successfully');
    } catch (err) {
      updateAt(selected, { isUploading: false });
      toast.error('Image upload failed');
    } finally {
      setUploading(false);
      e.target.value = '';
    }
  };

  const applyPreset = (key) => {
    setBlocks(PRESETS[key]());
    setSelected(null);
    setShowTemplates(false);
  };

  const handleApply = () => {
    const payload = JSON.stringify({ width: canvasWidth, background: canvasBg, blocks });
    onChange?.(payload);
    toast.success('Template applied — it will be saved when you submit the form');
  };

  const selectedBlock = getBlockAt(selected);

  return (
    <div className="page-builder border rounded-3 overflow-hidden" onClick={() => setSelected(null)}>
      {/* ADD toolbar */}
      <div className="d-flex flex-wrap align-items-center gap-2 p-2 border-bottom bg-white" onClick={(e) => e.stopPropagation()}>
        <span className="fw-semibold small text-muted me-1">ADD:</span>
        {ADD_TYPES.map((t) => (
          <button key={t} type="button" className="btn btn-sm btn-outline-secondary" onClick={() => addBlock(t)}>
            {TYPE_LABELS[t]}
          </button>
        ))}
      </div>

      {/* SETTINGS bar */}
      <div className="d-flex flex-wrap align-items-center gap-2 p-2 border-bottom bg-light" onClick={(e) => e.stopPropagation()}>
        <span className="fw-semibold small text-muted">SETTINGS:</span>
        <label className="small mb-0">BG:</label>
        <input type="color" value={canvasBg} onChange={(e) => setCanvasBg(e.target.value)} />
        <label className="small mb-0 ms-2">Width:</label>
        <select className="form-select form-select-sm" style={{ width: 160 }} value={canvasWidth} onChange={(e) => setCanvasWidth(Number(e.target.value))}>
          <option value={600}>600px — Standard</option>
          <option value={700}>700px — Wide</option>
          <option value={800}>800px — Extra Wide</option>
          <option value={1000}>1000px — Full</option>
        </select>

        <div className="ms-auto d-flex gap-2 position-relative">
          <button type="button" className="btn btn-sm btn-outline-dark" onClick={() => setShowTemplates((s) => !s)}>
            Templates
          </button>
          {showTemplates && (
            <div className="border rounded bg-white shadow-sm p-1" style={{ position: 'absolute', top: '110%', right: 0, zIndex: 20, width: 180 }}>
              <button type="button" className="btn btn-sm btn-light w-100 text-start" onClick={() => applyPreset('blank')}>
                Blank
              </button>
              <button type="button" className="btn btn-sm btn-light w-100 text-start" onClick={() => applyPreset('textImage')}>
                Text + Image
              </button>
              <button type="button" className="btn btn-sm btn-light w-100 text-start" onClick={() => applyPreset('bannerText')}>
                Banner + Text
              </button>
            </div>
          )}
          <button type="button" className={`btn btn-sm ${!previewMode ? 'btn-dark' : 'btn-outline-dark'}`} onClick={() => setPreviewMode(false)}>
            Edit
          </button>
          <button type="button" className={`btn btn-sm ${previewMode ? 'btn-dark' : 'btn-outline-dark'}`} onClick={() => setPreviewMode(true)}>
            Preview
          </button>
          <button type="button" className="btn btn-sm btn-primary" onClick={handleApply}>
            ✓ Apply Template
          </button>
        </div>
      </div>

      {/* Canvas + settings panel */}
      <div className="d-flex" style={{ minHeight: 420 }}>
        <div className="flex-grow-1 p-3" style={{ background: '#e9edf1', overflow: 'auto' }} onClick={() => setSelected(null)}>
          <div style={{ width: canvasWidth, maxWidth: '100%', margin: '0 auto', background: canvasBg, minHeight: 380 }} onClick={(e) => e.stopPropagation()}>
            {blocks.length === 0 && <p className="text-center text-muted py-5">Add blocks using the ADD toolbar above</p>}

            {previewMode
              ? blocks.map((b) => <BlockContent key={b.id} block={b} />)
              : blocks.map((block, idx) => (
                  <BlockNode
                    key={block.id}
                    block={block}
                    path={{ top: true, id: block.id }}
                    selected={selected}
                    canMoveUp={idx > 0}
                    canMoveDown={idx < blocks.length - 1}
                    onSelect={setSelected}
                    onMove={moveAt}
                    onDuplicate={duplicateAt}
                    onDelete={removeAt}
                    onAddChild={(colPath, type) => addBlock(type, colPath)}
                  />
                ))}
          </div>
        </div>

        {!previewMode && (
          <div className="border-start p-3 bg-white" style={{ width: 320, overflow: 'auto' }} onClick={(e) => e.stopPropagation()}>
            <SettingsPanel
              block={selectedBlock}
              onUpdate={(patch) => updateAt(selected, patch)}
              onAddColumn={addColumn}
              onRemoveColumn={removeColumn}
              onUpdateColumn={updateColumnProp}
              onImageUpload={handleImageUploadForSelected}
              uploading={uploading}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default PageBuilder;